import { render, staticRenderFns } from "./DocRepos.vue?vue&type=template&id=42a84e9c"
import script from "./DocRepos.vue?vue&type=script&lang=js"
export * from "./DocRepos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports